import React from 'react'
import PropTypes from 'prop-types'
import useStyles from './styles'
import {
  SchedulePageSkeletonFrame,
  SkeletonBlock,
  SkeletonText,
} from './skeleton-parts'

// More than fit on screen; the strip clips the overflow like the loaded page.
const DAY_CARD_COUNT = 14
const SLOTS_PER_GROUP = 6

const SlotGroupSkeleton = () => {
  const classes = useStyles()
  return (
    <div className={classes.dayPart}>
      <div className={classes.dayPartHeader}>
        <SkeletonBlock width={16} height={16} radius={8} />
        <SkeletonText width={88} height={16} />
      </div>
      <div className={classes.slotGrid}>
        {Array.from({ length: SLOTS_PER_GROUP }, (_, index) => (
          <SkeletonBlock key={index} height={40} radius={20} />
        ))}
      </div>
    </div>
  )
}

const DateStripSkeleton = ({ isCompact }) => {
  const classes = useStyles()
  return (
    <div className={classes.stripRow}>
      {!isCompact && <SkeletonBlock width={36} height={36} radius={18} />}
      <div className={classes.strip} style={{ overflow: 'hidden' }}>
        {Array.from({ length: DAY_CARD_COUNT }, (_, index) => (
          <SkeletonBlock
            key={index}
            width={72}
            height={68}
            radius={16}
            style={{ flex: '0 0 72px' }}
          />
        ))}
      </div>
      {!isCompact && <SkeletonBlock width={36} height={36} radius={18} />}
      <SkeletonBlock width={40} height={40} radius={20} />
    </div>
  )
}

DateStripSkeleton.propTypes = { isCompact: PropTypes.bool.isRequired }

// Placeholder for the redesigned step 1 while availability and feature flags
// load. Same frame, grid, cards and summary column as the loaded page so
// nothing shifts when it arrives.
const SelectTimeSkeletonRedesign = () => {
  const classes = useStyles()
  return (
    <SchedulePageSkeletonFrame testId="select-time-skeleton-redesign">
      {({ isCompact }) => (
        <>
          <SkeletonText width="45%" height={isCompact ? 36 : 44} />
          <SkeletonText width="70%" height={21} style={{ marginTop: 8 }} />
          <DateStripSkeleton isCompact={isCompact} />
          <div className={classes.timeCard}>
            <SkeletonText width="40%" height={28} />
            <SlotGroupSkeleton />
            <SlotGroupSkeleton />
          </div>
          <div className={classes.bottomBar}>
            <SkeletonText width="40%" height={21} />
            <SkeletonBlock width={112} height={47} radius={24} />
          </div>
        </>
      )}
    </SchedulePageSkeletonFrame>
  )
}

export default SelectTimeSkeletonRedesign
